import Oidc from "oidc-client";

async function checkIfUserSessionExists() {
	return new Promise((resolve) => {
		userManager.getUser().then(response => {
			if (response != null) {
				oidcResponse = response;
				resolve(true);
			}
			else {
				resolve(false);
			}
		}).catch(err => {
			console.warn(err);
			resolve(false);
		});
	})
}

function emitSilentRefreshEvent(user) {
	if (user != null) {
		const event = new CustomEvent("silentRefresh", {
			detail: {
				access_token: user.access_token
			}
		});
		document.dispatchEvent(event);
	}
}

let userManager = null;
let oidcResponse = null;

const oidcSettings = {
	scope: `openid profile email address offline_access ${process.env.VUE_APP_SCOPE}`,
	response_type: "code"
}

export default {
	configureUserManager: () => {
		userManager = new Oidc.UserManager({
			authority: process.env.VUE_APP_IDENTITY_SERVER_URL, // IDENTITY SERVER API URL
			client_id: process.env.VUE_APP_CLIENT_ID,
			redirect_uri: window.location.origin + "/callback", // Return back here
			response_type: oidcSettings.response_type,
			scope: oidcSettings.scope,
			revokeAccessTokenOnSignout: true,
			response_mode: "query",
			checkSessionInterval: 2000,
			includeIdTokenInSilentRenew: true,
			monitorSession: true,
			post_logout_redirect_uri: window.location.origin
		});
		return userManager;
	},

	startSessionListeners: async () => {
		userManager.events.addAccessTokenExpiring(() => {
			// Manually revoke access and refresh tokens ??
			userManager.signinSilent({scope: oidcSettings.scope, response_type: oidcSettings.response_type})
				.then((user) => {
					emitSilentRefreshEvent(user);
				})
				.catch((error) => {
					userManager.getUser().then((user) => {
						emitSilentRefreshEvent(user);
					});
				});
		});
	
		userManager.events.addUserSignedOut(() => {
			console.log("User signed out");
			document.location.href = "/";
		});
	},

	checkSessionStatus: () => {
		var expiresAt = oidcResponse.profile.session_expires_at;
		if (expiresAt != null) {
			let session_expires_unix;
			if (typeof(expiresAt) == "object") {
				session_expires_unix = parseInt(expiresAt[0]);
			} else if (typeof(expiresAt) == "string") {
				session_expires_unix = parseInt(expiresAt);
			}
			
			if (Date.now() > session_expires_unix) {
				window.location.reload();
			}
		}
	},

	checkIsUserLoggedIn: async () => {
		let isLoggedIn = await checkIfUserSessionExists();
		console.log(`Is user logged in: ${isLoggedIn}`);
		// If logged in, get user details and tokens
		if (isLoggedIn === true) {
			return {
				result: oidcResponse
			};
		} else if (isLoggedIn === false) {
			// If not logged in, redirect to login view in identity server
			return userManager.signinRedirect().then(res => {})
			.catch(err => {
				console.warn(err);
				return false;
			});
		}
	},

	handleLoginCallback: () => {
		userManager.signinRedirectCallback().then(response => {
			if (response != null) {
				document.location.href = "/";
			}
		}).catch(err => {
			console.warn(err);
			if (err && err.error && err.error.includes("login_required")) {
				userManager.signoutRedirect().then(res => {});
			}
		});
	},

	logout: (idToken) => {
		userManager.signoutRedirect({ "id_token_hint": idToken }).then(res => {});
	}
}